var chroma = require("chroma-js"),
    Immutable = require("immutable");
var {grammar, semantics} = require("../../../language.js");

let lightness = 55,
    saturation = 73,
    hueRange = 140;

let ruleNames = Object.keys(grammar.ruleBodies);
let numRules = ruleNames.length + 2;
let ruleColorMap = new Immutable.Map(
  ruleNames.map((ruleName, i) =>
    [ruleName, chroma.hcl(180 + hueRange/numRules * i, saturation, lightness).alpha(0.25)])
);

ruleColorMap = ruleColorMap.set('_iter',
  chroma.hcl(180 + 180/numRules * ruleNames.length, saturation, lightness).alpha(0.25));

ruleColorMap = ruleColorMap.set('_terminal',
  chroma.hcl(180 + 180/numRules * (ruleNames.length+1), saturation, lightness).alpha(0.25));

var annotationColor = chroma.hcl(0, 0, 70).alpha(0.25);
var annotationHighlightColor = /*chroma.hcl(250, 35, 50)*/chroma('#E7FB2D');//.alpha(0.90);

var toExport = {
  ruleColorMap,
  annotationColor,
  annotationHighlightColor
}

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}



/** WEBPACK FOOTER **
 ** ./src/components/exampleRepresentation/visualizationOverlay/colorScheme.js
 **/